import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CurrencyDollar, Package, ShoppingCart, WarningCircle } from "@phosphor-icons/react";

export default function AdminAnalytics() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/store/analytics").then((r) => setData(r.data)); }, []);

  if (!data) return <div className="text-[var(--text-2)]">Loading…</div>;

  const cards = [
    { label: "Revenue", value: `R${data.total_revenue.toFixed(2)}`, icon: CurrencyDollar, colour: "var(--green)" },
    { label: "Orders", value: data.total_orders, icon: ShoppingCart, colour: "var(--blue)" },
    { label: "Products", value: data.product_count, icon: Package, colour: "var(--red)" },
    { label: "Low stock", value: data.low_stock, icon: WarningCircle, colour: "var(--yellow)" },
  ];

  return (
    <div className="space-y-6">
      <div>
        <span className="label-eyebrow">Analytics</span>
        <h1 className="mt-1 font-display text-4xl">Performance</h1>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((c) => (
          <div key={c.label} className="card-panel p-5">
            <div
              className="w-12 h-12 rounded-full border-2 border-[var(--text)] flex items-center justify-center text-white"
              style={{ background: c.colour, boxShadow: "3px 3px 0 0 var(--text)" }}
            >
              <c.icon size={22} weight="fill" />
            </div>
            <p className="mt-4 font-display text-3xl">{c.value}</p>
            <p className="text-xs font-bold uppercase tracking-widest text-[var(--text-2)]">{c.label}</p>
          </div>
        ))}
      </div>
      <div className="card-panel p-6">
        <h3 className="label-eyebrow mb-4">Orders by status</h3>
        <div className="space-y-2">
          {data.by_status.length === 0 && (
            <p className="text-sm text-[var(--text-2)]">No orders yet.</p>
          )}
          {data.by_status.map((b) => (
            <div key={b._id} className="flex items-center justify-between text-sm py-2 border-b border-[var(--text)]/10 last:border-0">
              <span className="capitalize font-bold">{b._id.replace("_", " ")}</span>
              <span className="text-[var(--text-2)]">
                {b.count} orders · R{b.revenue.toFixed(2)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
